import React, { lazy } from 'react';
import { type Route, type Routes } from 'react-resource-router';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const InferencePage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-inference" */ '../../pages/inference/InferencePage'
		),
);

const InferencePageWithAccess: React.FC = () => (
	<AppAccessGate appName="Labs">
		<InferencePage />
	</AppAccessGate>
);

const ROUTE_PREFIX = '/inference' as const;

const inferenceRoutesObject: Record<string, Route> = {
	home: {
		name: 'inference',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(InferencePageWithAccess),
	},
};

export const inferenceRoutes: Routes = Object.values(inferenceRoutesObject);
